import { Component } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AppService } from '../../services/app.service';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  data: any = {};
  $appData: Subscription;
  currentRoute: string = '';

  constructor(private apiService: ApiService, private appService: AppService, private route: ActivatedRoute, private router: Router) {
    this.$appData = this.apiService.$appData.subscribe(data => { this.applyValues(data); });      
    this.router.events.subscribe(() => {
      var path = this.router.url.split("?")[0]
      this.currentRoute = path;
    });

    var path = this.router.url.split("?")[0]
    this.currentRoute = path;
  }
  applyValues(res: any) {
    this.data = res;
  }

  ngOnInit() {
    const data = this.apiService.getData();
    this.applyValues(data);
  }

  showTerms(){
    this.appService.changeTermsVisibility();
  }

  ngOnDestroy() {
    if (this.$appData) { this.$appData.unsubscribe(); }
}

}
